// @ vendors
const { Promise } = require('es6-promise');

// @ commons
const { get, set, has, filter, merge } = require('lodash');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @ actions
const { resetCoHolderInformation } = require('actions/mortgageRequest/mortgageHoldersDataValidation');

// @ constants
const {
    MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_REQUEST,
    MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_SUCCESS,
    MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_FAILURE,
    MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_REQUEST,
    MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_SUCCESS,
    MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_FAILURE,
    MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_REQUEST,
    MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_SUCCESS,
    MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_FAILURE,
    MORTGAGE_REQUEST_UPDATE_DATA_PROPRIETOR_SUCCESS,
    MORTGAGE_REQUEST_FETCH_STATE_FAILURE
} = require('constants/actionTypes');
const { UNKNOWN } = require('constants/index');
const requestSummaryDocumentationInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_REQUEST
});

const requestSummaryDocumentationSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_SUCCESS,
    data
});

const requestSummaryDocumentationFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_FAILURE,
    data: { error }
});

const requestDataProprietorInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_REQUEST
});

const requestDataProprietorSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_SUCCESS,
    data
});

const requestDataProprietorFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_FAILURE,
    data: { error }
});
const requestDataProprietorFailureState = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_STATE_FAILURE,
    data: { error }
});
const deleteDataProprietorInProgress = () => ({
    type: MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_REQUEST
});

const deleteDataProprietorSuccess = () => ({
    type: MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_SUCCESS
});

const deleteDataProprietorFailure = (error) => ({
    type: MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_FAILURE,
    data: { error }
});

const requestSummaryDocumentation = (idExpediente, numeroDocumento, tipoDocumento) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestSummaryDocumentation;
    const isAlreadyFetching = currentState.get('isFetching');
    const omitirDocumentoUsuario = !numeroDocumento || !tipoDocumento;
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                from: 0,
                howmany: 0,
                idExpediente,
                numeroDocumento,
                tipoDocumento,
                omitirDocumentoUsuario
            }
        };
        dispatch(requestSummaryDocumentationInProgress());
        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestSummaryDocumentation',
            params: requestData
        })
            .then(response => dispatch(requestSummaryDocumentationSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestSummaryDocumentationFailure(response.error));
                } else {
                    throw response;
                }
            })
    } else {
        return Promise.resolve()
    }
};

const requestDataWork = (dataProprietorsList) => (dispatch) => {
    const proprietorsList = get(dataProprietorsList, 'data', []);
    const proprietorsFilter = filter(proprietorsList, obj => {
        const numeroTitular = get(obj, 'numeroTitular', 0);
        const tipoDocumentoIdentidad = get(obj, 'datosPersonales.documentoDeIdentidad.tipoDocumentoIdentidad', UNKNOWN);
        const identificador = get(obj, 'datosPersonales.documentoDeIdentidad.identificador', UNKNOWN);
        const numclienteobcd = get(obj, 'numclienteobcd', UNKNOWN);
        if (tipoDocumentoIdentidad === UNKNOWN) {
            dispatch(requestDataProprietorFailureState(true))
            dispatch(requestDataProprietorFailure(true));
        } else {
            return numeroTitular
                && (tipoDocumentoIdentidad !== '' && tipoDocumentoIdentidad !== UNKNOWN)
                && (identificador !== '' && identificador !== UNKNOWN)
                && (numclienteobcd !== '' && numclienteobcd !== UNKNOWN);
        }
    });
    const dataWorksRequest = proprietorsFilter.map(proprietor => {
        const tipoDocumentoIdentidad = get(proprietor, 'datosPersonales.documentoDeIdentidad.tipoDocumentoIdentidad');
        const numeroDocumento = get(proprietor, 'datosPersonales.documentoDeIdentidad.identificador');
        const requestData = {
            query: {
                tipoDocumentoIdentidad,
                numeroDocumento
            }
        };

        return new Promise((resolve) => {
            APIPost({
                dispatch,
                endpoint: 'mortgageRequesWorkDataRequest',
                params: requestData
            })
                .then(response => resolve(response))
                .catch(response => resolve({
                    success: false,
                    response
                }))
        });
    });

    return Promise.all(dataWorksRequest)
        .then((dataWorks) => {
            const parsedDataWorks = dataWorks.map((dataWork, index) => {
                if (has(dataWork, 'data')) {
                    return merge(proprietorsFilter[index], {
                        datosEmpleo: get(dataWork, 'data')
                    });
                } else {
                    return proprietorsFilter[index];
                }
            });

            set(dataProprietorsList, 'data', parsedDataWorks);
            return dataProprietorsList;
        })
};

const requestDataProprietor = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestDataProprietor;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {

        dispatch(requestDataProprietorInProgress());
        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestDataProprietorRequest'
        })
            .then(responseDataProprietor => dispatch(requestDataWork(responseDataProprietor)))
            .then(responseDataWork => dispatch(requestDataProprietorSuccess(responseDataWork)))
            .catch(failResponse => {
                if (!!failResponse.error) {
                    dispatch(requestDataProprietorFailure(failResponse.error));
                } else {
                    throw failResponse;
                }
            })
    } else {
        return Promise.resolve()
    }
};

const deleteDataProprietor = (numeroTitular) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestDataProprietorDelete;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const url = apiURLBuilder.getURL('mortgageRequestDataProprietorDelete');
        dispatch(deleteDataProprietorInProgress());
        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestDataProprietorDelete',
            url: `${url}?numeroTitular=${numeroTitular}`
        })
            .then(() => dispatch(deleteDataProprietorSuccess()))
            .then(() => dispatch(resetCoHolderInformation()))
            .catch(response => {
                if (!!response.error) {
                    dispatch(deleteDataProprietorFailure(response.error));
                } else {
                    throw response;
                }
            })
    } else {
        return Promise.resolve()
    }
};

const setProprietorId = (id) => ({
    type: MORTGAGE_REQUEST_UPDATE_DATA_PROPRIETOR_SUCCESS,
    data: {
        idProprietor: id
    }
});

module.exports = {
    requestDataProprietorInProgress,
    requestDataProprietorSuccess,
    requestDataProprietorFailure,
    requestSummaryDocumentation,
    requestDataProprietor,
    requestDataWork,
    deleteDataProprietor,
    setProprietorId
};
